import http from '@/utils/http'

const initialState = () => ({
  list: []
})

export const state = initialState()

export const mutations = {
  RESET (state) {
    const newState = initialState()
    Object.keys(newState).forEach(key => {
      state[key] = newState[key]
    })
  },
  SET_LIST (state, list) {
    state.list = list
  }
}

export const getters = {
  list: state => state.list
}

export const actions = {
  fetchDataconnectors ({ commit, rootGetters }) {
    return http({
      url: `${process.env.VUE_APP_API_URL}dataconnectors/${rootGetters['auth/token']}`
    }).then(data => {
      commit('SET_LIST', data)
    })
  }
}
